module.exports = __webpack_public_path__ + "img/bg-type06-pc.4c9e1ce7.png";